import React from "react"

import { AppDropoffOfficesAutocomplete } from "@components"
import { BACKEND_APIS } from "@constants"
import { errors, officesPickoff } from "@signals"


export default function DropoffOfficesAutocomplete({ ...props }) {
	return <AppDropoffOfficesAutocomplete
		value={officesPickoff.value || null}
		error={errors.value?.officeDropoffID}
		onChange={e => officesPickoff.value = e.target.value || null}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/execution/options/dropoff-offices`}
		{...props}
	/>
}
